import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ServiceCategoryModel, ServiceModel } from 'src/app/store/self-diagnostic/service-catalog/model';
import { List } from '../../../../../../core/infrastructure/linq';
import { ServiceCatalogFacade } from '../../../../../../store/self-diagnostic/service-catalog/facade';
import { DialogEditIconComponent } from '../../dialogs/dialog-edit-icon/dialog-edit-icon.component';
import { DialogUpdateCategoryComponent } from '../../dialogs/dialog-update-category/dialog-update-category.component';
import { AppConstants } from '../../../../../../core/constants/app-constants';
import { UserFacade } from '../../../../../../store/user/facade';
import { UserModel } from '../../../../../../store/user/model';

@Component({
  selector: 'service-catalog-categories',
  templateUrl: './service-catalog-categories.component.html',
  styleUrls: ['./service-catalog-categories.component.scss'],
  host: {
    class: 'p-4',
  },
  standalone: false,
})
export class ServiceCatalogCategoriesComponent implements OnInit {
  translate = inject(TranslateService);
  private facade = inject(ServiceCatalogFacade);
  sanitizer = inject(DomSanitizer);
  private titleService = inject(Title);
  private userFacade = inject(UserFacade);

  public categories: ServiceCategoryModel[] = [];
  @ViewChild(DialogEditIconComponent) dialogEditIcon: DialogEditIconComponent;
  @ViewChild(DialogUpdateCategoryComponent) dialogUpdateCategory: DialogUpdateCategoryComponent;
  public user: UserModel;
  public isLanguageUa: boolean;

  public async ngOnInit() {
    // Page title
    this.translate.get('TITLE_MAIN').subscribe(value => {
      this.titleService.setTitle(value);
    });

    // Get current language
    this.userFacade.selected().subscribe(user => {
      this.user = { ...user };

      this.isLanguageUa = !this.user?.language || this.user?.language == AppConstants.LANGUAGE_UK;
    });

    this.facade.entities$.subscribe(s$ => {
      this.categories = new List<ServiceModel>(s$)
        .Select(s => s.category)
        .DistinctBy(sc => sc.code)
        .OrderBy(sc => sc.nameUa)
        .Select(
          sc =>
            <ServiceCategoryModel>{
              id: sc.id,
              code: sc.code,
              nameUa: sc.nameUa,
              nameRu: sc.nameRu,
              webNameUa: sc.webNameUa,
              webNameRu: sc.webNameRu,
              descriptionUa: sc.descriptionUa,
              descriptionRu: sc.descriptionRu,
              priority: sc.priority,
              iconBody: sc.iconBody,
              iconType: sc.iconType,
              masterCategoryId: sc.masterCategoryId,
              masterCategory: sc.masterCategory,
            }
        )
        .ToArray();
    });
  }

  public upPriority($event, entity) {
    $event.event.preventDefault();
    $event.event.stopPropagation();

    let category = <ServiceCategoryModel>entity.data;

    this.facade.upPriorityCategory(category);
  }

  public downPriority($event, entity) {
    $event.event.preventDefault();
    $event.event.stopPropagation();

    let category = <ServiceCategoryModel>entity.data;

    this.facade.downPriorityCategory(category);
  }

  public uploadIcon($event, entity) {
    $event.event.preventDefault();
    $event.event.stopPropagation();

    let category = <ServiceCategoryModel>entity.data;

    this.dialogEditIcon.show().subscribe(result => {
      if (result) {
        this.facade.uploadCategoryIcon(category, result);
      }
    });
  }

  public deleteIcon($event, entity) {
    $event.event.preventDefault();
    $event.event.stopPropagation();

    let category = <ServiceCategoryModel>entity.data;

    this.facade.deleteCategoryIcon(category);
  }

  public sync() {
    this.facade.sync();
  }

  public rowClick($event) {
    if ($event.isExpanded) {
      $event.component.collapseRow($event.data.id);
    } else {
      $event.component.expandRow($event.data.id);
    }
  }

  public onSave(srcCategory: ServiceCategoryModel) {
    let category = <ServiceCategoryModel>{
      id: srcCategory.id,
      code: srcCategory.code,
      nameUa: srcCategory.nameUa,
      nameRu: srcCategory.nameRu,
      webNameUa: srcCategory.webNameUa,
      webNameRu: srcCategory.webNameRu,
      priority: srcCategory.priority,
      descriptionUa: srcCategory.descriptionUa,
      descriptionRu: srcCategory.descriptionRu,
      iconBody: srcCategory.iconBody,
      iconType: srcCategory.iconType,
      masterCategoryId: srcCategory.masterCategoryId,
    };

    this.facade.updateCategory(category);
  }
}
